import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { URLS } from '../../resources/constants'
import { getUser } from '../../store/user/selectors'
import { useUserApi } from '../../resources/hooks/api/userApiHook'
import { getAccessToken } from '../../store/user/selectors'
//import { useUserDataApi } from '../../resources/hooks/api/userDataApiHook'
import { CustomTable } from '../../components'
import { useNavigate, Link, useSearchParams } from 'react-router-dom'
import { updateUser, authenticateUser, updateAccessToken } from "../../store/user";
import { resetSettings } from '../../store/settings'
import { store } from '../../store';
import pleaseWait from '../../assets/images/loader.webp';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';




interface Props {

}

const UserVerification: React.FC<Props> = () => {

  const _users = useSelector(getUser)
  const { userAccess, fetchUserData } = useUserApi();
  const [searchParams, setSearchParams] = useSearchParams();

  const dispatch = useDispatch();

  const { i18n } = useTranslation();
  const { t } = useTranslation("scenes.userverification"); 

  const navigate = useNavigate();
  useEffect(() => {
    const params: any = {};
    if (searchParams.get('token')) {
      params['token'] = searchParams.get('token');
    }
    if (searchParams.get('dataImportOption')) {
      params['accounting_type'] = searchParams.get('dataImportOption');
    }

    i18n.changeLanguage(searchParams.get('language') || 'en');
    dispatch(resetSettings());
    userAccess(params, (message: string, resp: any) => {
      navigate(URLS.DASHBOARD);
    }, (message: string, resp: any) => {
    })
  }, [])


  return (
    <>
      <div>
        <center><img src={pleaseWait} className="App-logo" alt="logo" width="50" /></center>
        <center><p><b>{t('loading')}</b></p></center>
      </div>

    </>

  )
}

export default UserVerification;